module.exports = __webpack_public_path__ + "media/images/ghost-logo-618f96f35e665232ace1e47d04f89ad1.png";